import React, { forwardRef, useEffect } from "react";
import { Toast } from "primereact/toast";

const CustomToast = forwardRef((props, ref) => {
  useEffect(() => {
    if (ref && ref.current && props.toastOptions) {
      ref.current.show({
        severity: props.toastOptions.severity,
        summary: props.toastOptions.summary,
        detail: props.toastOptions.detail,
        life: 3000,
      });
    }
  }, [props.toastOptions, ref]);

  return <Toast ref={ref} position="top-right" />;
});

export default CustomToast;
